<template>
  <div class="e6Warp">
    <versionNav></versionNav>
    <div style='width:100%;height:106px'></div>
    <div class="inner">
      <div class="e8title">
        <img
          src="//cdn1.zygames.com/qqsm/Public/img/version/e8titlenew.png"
          width="941"
          height="146"
        />
        <div class="wz">
          <p>活动范围 <span>全区</span></p>
        </div>
      </div>
      <div class="e8table">
        <div class="e8lt1">
          <p>活动规则：</p>
          <p>
            1. {{Stime}}维护后，所有在《全球使命3》单区单笔首次充值达到10元面值点券(1000点券)的玩家，次日都可获得一份豪华礼包，内含：<br>
            <!-- 1. <em :for="(st) in hotMovie">{{st.boxStartTime}}</em>维护后，所有在《全球使命3》单区单笔首次充值达到10元面值点券(1000点券)的玩家，次日都可获得一份豪华礼包，内含：<br> -->
            <ul class="e8lt1-r"> &nbsp;&nbsp;
              <li v-for="(boxs,key) in boxList" :key="key">
                <img :src="boxs.boxsrc" :alt="boxs.boxname"><span>{{ boxs.boxname }}</span>
              </li>
            </ul>
            
          </p>
          <p>
            2. 所有奖励将通过游戏内邮件的方式即时发送给玩家，为避免不必要的损失，请玩家于活动之前清理多余的邮件；
          </p>
          <p>
            3. 由于奖品发放数量较大，可能会出现最多1小时的延迟现象，请玩家耐心等待。如一小时后仍未收到奖励邮件，可通过客服邮件或<br>电话的方式联系我们，有当值客服为您解决问题。
          </p>
        </div>
        <div class="clearfloat"></div>
        <div class="seemore"><a href="http://cdn1.zygames.com/qqsm/events_info/m3sc/index.html" target="_blank"><img src="//cdn1.zygames.com/qqsm/Public/img/version/ButtonSeeMore.png" alt=""></a></div>
      </div>
      <div class="h50"></div>
    </div>
  </div> 
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name:"e6",
  data() {
    return {
      hotMovie: [],
      boxList: [],
      Stime: ""
    }
  },
  computed: {
    ...mapGetters(["FirstRecharge"])
  },
  created(){
    var url = 'https://passport.zygames.com/Banner/GetMagicBoxes?id='+this.FirstRecharge.frDataID;

    this.$jsonp(url,{
      callbackQuery: 'jsonpcallback', // jsonp key //请求传递参数 1
      callbackName: 'jsonp' // jsonp key //请求传递参数 2
    })
    .then(res => {
          this.hotMovie = res.Data.MagicBox.filter(item => {
            return item.Type === '限时充值送礼';
          }).map(item => {
            return {
              boxId:item.Id,
              boxStartTime:moment(item.StartTime).utc(8).format('YYYY年M月D日'),
            }
          })
          this.Stime = this.hotMovie[0].boxStartTime
          var boxid = this.hotMovie[0].boxId;
          this.$jsonp(url,{
              callbackQuery: 'jsonpcallback', // jsonp key //请求传递参数 1
              callbackName: 'jsonp' // jsonp key //请求传递参数 2
          })
          .then(jsonp => {
              this.boxList = jsonp.Data.MagicBoxItems.filter(datas => {
                return datas.MagicBoxId === boxid
              }).map(datas => {
                return {
                  boxname: datas.Name,
                  // boxcode: datas.Code
                  boxsrc: 'http://cdn1.zygames.com/qqsm/t1/s/'+datas.Code+'.png'
                }
              })
              // console.log(this.boxList);
          }).catch(err => {
            // console.log(err)
          })
    }).catch(error => {
      // console.log(error)
    });
  },

  mounted () {
  },
  methods:{
    // getSeclect(){
    
    // }
  }
}
</script>

<style scoped>
@import "./pagesCss/e6.css"
</style>


// WEBPACK FOOTER //
// src/pages/e6.vue